import { render, staticRenderFns } from "./CreateItemCodeModal.vue?vue&type=template&id=db2fffc8&scoped=true"
import script from "./CreateItemCodeModal.vue?vue&type=script&lang=js"
export * from "./CreateItemCodeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateItemCodeModal.vue?vue&type=style&index=0&id=db2fffc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2fffc8",
  null
  
)

export default component.exports